import React from 'react'

const HomePage = () => {
  return (
    <div>
      <h3>Welcome!!</h3>
    </div>
  )
}

export default HomePage
